<template>
  <div>
    <common-banner :imgSrc="imgPath" :imgLabel="imgLabel" :path="'/opendata'"></common-banner>
    <home-main>
      <template slot="slot">
        <el-row class="dataset-layout" :gutter="24">
          <el-col :span="7" class="dataset-sidebar">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="dataset-breadcrumb">
              <el-breadcrumb-item :to="{ path: '/' }"><i class="el-icon-s-home"></i> 数据库</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/dataset' }"><i class="el-icon-coin"></i> 条件搜索</el-breadcrumb-item>
            </el-breadcrumb>
            <dropper :filterData="filterData" v-model="query"></dropper>
            <a
              class="dataset-demand-link"
              :href="demandStationUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>找不到你要的数据？</span>
              <span>点击提交需求</span>
            </a>
          </el-col>
          <el-col :span="17" v-loading="loading" class="dataset-content">
            <el-row class="dataset_search">
              <search @search="onSearch"></search>
            </el-row>
            <el-row>
              <el-tag v-for="item in queryTags" :key="item.name" closable="" :type="item.type" @close="onClose(item)" style="margin: 5px;">{{item.name}}</el-tag>
            </el-row>
            <carder v-for="entry in entries" :key="entry.id"
                    @router-to="handleRouterTo(entry)"
                    :item="entry"
                    :tags="getEntryTags(entry)"></carder>
            <el-pagination class="pagination" v-show="entryCount>0" background layout="total, sizes, prev, pager, next" :total="entryCount" :current-page.sync="page" :page-size="pageSize" :page-sizes="[10,20,50,100]" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
          </el-col>
        </el-row>
      </template>
    </home-main>
  </div>
</template>

<script>
// import axios from 'axios'
import CommonBanner from '@/pages/common/Banner'
import HomeMain from '@/pages/homepage/components/Main'
import Dropper from '@/pages/common/Dropper'
import Carder from '@/pages/common/Carder'
import Search from '@/pages/common/Search'
import { getFilters, getEntries, points, parseParams } from '@/api/search'
import lodash from 'lodash'
export default {
  name: 'DataSet',
  components: {
    HomeMain,
    CommonBanner,
    Dropper,
    Carder,
    Search
  },
  data () {
    return {
      imgPath: require('@/assets/images/banner/dataset_banner.jpg'),
      imgLabel: '开放数林',
      demandStationUrl: 'https://jsj.top/f/WNLWeF',
      filterData: [],
      query: {
        fileTitle: this.$route.query.query || '',
        province: this.$route.query.province || '',
        city: this.$route.query.city || '',
        department: this.$route.query.department || '',
        provincial: ''
      },
      searchInput: this.$route.query.query || '',
      isFree: {
        val: this.$route.query.free || '-1',
        options: [{label: '全部', val: '-1'}, {label: '无条件开放', val: '1'}, {label: '有条件开放', val: '0'}]
      },
      subject: {
        vals: this.$route.query.subject instanceof Array ? this.$route.query.subject : this.$route.query.subject ? [this.$route.query.subject] : [],
        options: ['交通出行', '卫生健康', '经贸工商', '社会民生', '教育科技', '公共安全', '财税金融', '社保就业', '资源环境', '城建住房', '农业农村', '文化休闲', '信用服务', '机构团体', '其他']
      },
      page: 1,
      pageSize: 10,
      entries: [],
      entryCount: 0,
      loading: false
    }
  },
  computed: {
    queryObj () {
      return JSON.parse(JSON.stringify(this.query))
    },
    queryTags: {
      get () {
        const vals = this.query
        let tags = Object.keys(vals)
          .filter(key => vals[key] !== '' &&
            this.filterData.find(x => x.key === key) &&
            this.filterData.find(x => x.key === key).items &&
            this.filterData.find(x => x.key === key).items.find(x => x.value === vals[key]) &&
            this.filterData.find(x => x.key === key).items.find(x => x.value === vals[key]).name)
          .map(key => Object({
            name: this.filterData.find(x => x.key === key).items.find(x => x.value === vals[key]).name,
            type: '',
            key: key
          }))
        if (this.query.fileTitle) {
          tags.push({name: this.query.fileTitle, type: '', key: 'query'})
        }
        if (this.subject.vals.length > 0) {
          this.subject.vals.forEach(x => {
            tags.push({name: x, type: '', key: 'subject'})
          })
        }
        if (this.isFree.val !== '-1') {
          tags.push({name: this.isFree.val === '0' ? '有条件开放' : '无条件开放', type: '', key: 'free'})
        }
        return tags
      }
    }
  },
  mounted () {
    // this.pushProvinces()
    points()
    this.pushFilters()
    this.$nextTick(() => {
      this.search()
    })
  },
  methods: {
    onSearch (query) {
      this.page = 1
      if (query) {
        parseParams({query: query.query}).then(({data}) => {
          this.query = {
            ...query,
            page: this.page,
            pageSize: this.pageSize,
            ...data
          }
        })
      } else {
        this.search()
      }
      // this.query.province = query.province
      // this.query.city = query.city
      // this.query.department = query.department
      // this.query = query
      // var param = {
      //   page: this.page,
      //   pageSize: this.pageSize,
      //   provinceCode: query.province,
      //   cityCode: query.city,
      //   department: query.department,
      //   subjects: query.subject,
      //   isFree: query.free,
      //   fileTitle: query.query
      // }
      // this.searchInput = query.query
      // this.subject.vals = query.subject || []
      // this.isFree.val = query.free || '-1'
      // this.debouncedGetEntries(this, param)
    },
    search () {
      var param = {
        page: this.page,
        pageSize: this.pageSize,
        provinceCode: this.query['province'],
        cityCode: this.query['city'],
        department: this.query['provincial'] || this.query['department'],
        subjects: this.subject.vals,
        isFree: this.isFree.val,
        fileTitle: this.query.fileTitle
      }
      this.entries = []
      // this.entryCount = 0
      // if (param.provinceCode || (param.subjects && param.subjects.length > 0) || param.isFree !== '-1' || param.fileTitle) {
      this.debouncedGetEntries(this, param)
      // }
    },
    debouncedGetEntries: lodash.debounce((that, param) => {
      that.loading = true
      getEntries(param).then(({data}) => {
        that.loading = false
        that.entries = data.records
        that.entryCount = data.total
      })
    }, 200),
    handleCurrentChange (val) {
      this.page = val
      this.search()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.search()
    },
    handleRouterTo (entry) {
      var location = { path: '/detail', query: { entryid: entry.id } }
      this.$router.push(location)
    },
    pushFilters () {
      const params = {
        ...this.query,
        subjects: this.subject.vals
      }
      getFilters(params).then(({data}) => {
        data.forEach(filter => {
          if (this.filterData.some(x => x.key === filter.key)) {
            const item = this.filterData.find(x => x.key === filter.key)
            item.show = filter.show
            item.collapse = filter.collapse
            item.title = filter.title
            item.items = filter.summaries.map(p => Object({name: p.name, value: p.code, count: p.count}))
            item.value = this.query[filter.key]
          } else {
            this.filterData.push({
              title: filter.title,
              key: filter.key,
              icon: 'city',
              component: () => import('@/pages/common/Spanner'),
              items: filter.summaries.map(p => Object({ name: p.name, value: p.code, count: p.count })),
              value: this.query[filter.key],
              show: filter.show,
              collapse: filter.collapse
            })
          }
        })
      })
    },
    onClose (item) {
      if (item.key === 'query') {
        this.$router.replace({query: ''})
        this.searchInput = ''
        this.query.fileTitle = ''
        this.search()
      } else if (item.key === 'subject') {
        this.subject.vals.splice(this.subject.vals.findIndex(x => x === item.name), 1)
      } else if (item.key === 'free') {
        this.isFree.val = '-1'
      } else {
        this.query[item.key] = ''
      }
    },
    getEntryTags (entry) {
      const files = JSON.parse(entry.dataSetFiles)
      let colors = new Set()
      if (files) {
        files.map(f => f.toLowerCase()).forEach((file) => {
          if (file.includes('json')) {
            colors.add('json')
          }
          if (file.includes('pdf')) {
            colors.add('pdf')
          } else if (file.includes('xml')) {
            colors.add('xml')
          } else if (file.includes('csv')) {
            colors.add('csv')
          } else if (file.includes('xlsx')) {
            colors.add('xlsx')
          } else if (file.includes('xls')) {
            colors.add('xls')
          } else if (file.includes('docx')) {
            colors.add('docx')
          } else if (file.includes('doc')) {
            colors.add('doc')
          } else if (file.includes('rdf')) {
            colors.add('rdf')
          } else if (file.includes('zip')) {
            colors.add('zip')
          } else if (file.includes('rar')) {
            colors.add('rar')
          }
        })
      }
      return [...colors]
    }
  },
  watch: {
    queryObj: {
      handler (val, oldVal) {
        console.log('val', val)
        console.log('oldVal', oldVal)
        if (val.province !== oldVal.province && val.city !== oldVal.city) {
          this.page = 1
          this.pushFilters()
          this.search()
          return
        }

        if (val.province !== oldVal.province) {
          this.query.city = ''
          this.query.department = ''
          this.query.provincial = ''
        } else if (val.city !== oldVal.city) {
          this.query.department = ''
          this.query.provincial = ''
        }

        this.page = 1
        this.pushFilters()
        this.search()
      },
      deep: true
    },
    // 'query.province' (val) {
    //   this.filterData.find(x => x.key === 'province').value = val
    //   this.query.city = ''
    //   this.query.provincial = ''
    //   this.page = 1
    //   this.pushFilters()
    //   console.log('query.province')
    //   this.search()
    // },
    // 'query.city' (val) {
    //   this.filterData.find(x => x.key === 'city').value = val
    //   this.page = 1
    //   this.query.department = ''
    //   this.query.provincial = ''
    //   this.pushFilters()
    //   console.log('query.city')
    //   this.search()
    // },
    // 'query.department' (val) {
    //   this.page = 1
    //   this.filterData.find(x => x.key === 'department').value = val
    //   console.log('query.department')
    //   this.search()
    // },
    // 'query.provincial' (val) {
    //   this.page = 1
    //   this.filterData.find(x => x.key === 'provincial').value = val
    //   console.log('query.provincial')
    //   this.search()
    // },
    'subject.vals' (vals) {
      this.page = 1
      console.log('subject.vals')
      this.pushFilters()
      this.search()
    },
    'searchInput' (val) {
      console.log('searchInput')
      this.search()
    },
    'isFree.val' (val) {
      console.log('isFree.val')
      this.search()
    }
  }
}
</script>

<style scoped>
.dataset-layout {
  margin-top: 20px;
}

.dataset-sidebar {
  margin-bottom: 20px;
}

.dataset-breadcrumb {
  margin-bottom: 20px;
}

.dataset-content {
  margin-top: 32px;
  margin-bottom: 20px;
}

.pagination {
  margin: 20px;
}

.dataset_search /deep/ input {
  height: 50px;
}

.dataset-demand-link {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: fit-content;
  margin: 30px auto 0;
  padding: 8px 55px;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  box-shadow: 0 10px 24px rgba(71, 199, 232, 0.24);
  background-color: rgb(0, 111, 111);
}

.dataset-demand-link span:first-child {
  white-space: nowrap;
}

@media screen and (max-width: 1200px) {
  .dataset-sidebar,
  .dataset-content {
    width: 100%;
  }

  .dataset-content {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/DataSetPage.vue